// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"1457480b","453":"c79b7fd4","777":"19f02e67"}[chunkId] + ".chunk.js";
};